import periodsApi from '../../../services/plataforma/periods';

export default {
  getPeriodsSelectOptions({ commit }) {
    return periodsApi.getAll({ selectList: true })
      .then(response => {
        commit('SET_PERIODS_COMBO', response.data);
        return Promise.resolve(response.data);
      })
      .catch(e => Promise.reject(e.response.data.error));
  },
  getAll(_, { page, name, status, perPage, sortBy, order }) {
    return periodsApi.getAll({ page, name, status, perPage, sortBy, order })
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  delete(_, id) {
    return periodsApi.delete(id)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  create(_, period) {
    return periodsApi.create(period)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  edit(_, period) {
    return periodsApi.edit(period)
      .then(response => Promise.resolve(response.data))
      .catch(e => Promise.reject(e.response.data.error));
  },
  setAlert({ commit }, value) {
    commit('SET_ALERT_REMOVE', value);
  },
  setPeriod({ commit }, period) {
    commit('SET_PERIOD', period);
  },
  setOverlay({ commit }, status) {
    commit('SET_OVERLAY', status);
  },
  getEnrolledPeriods(_, { state, academicMainTypeName }) {
    return periodsApi.getEnrolledPeriods({ state, academicMainTypeName })
      .then((response) => {
        return Promise.resolve(response);
      })
      .catch((error) => {
        return Promise.reject(error.response.data.error.message);
      });
  }
};
